import React, { useState } from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label } from 'reactstrap';

const ArtistTrackDownloadModal = ({
    artistName,
    artistGUID,
    artistTracks = [],               // ⬅️ default to []
    setArtistTracks = () => { },
    artistLongTracks = [],           // ⬅️ default to []
    setArtistLongTracks = () => { },
    artistPersonalTracks = [],           // ⬅️ default to []
    setArtistPersonalTracks = () => { },
    artistSearch = [],               // ⬅️ default to []
    setArtistSearch = () => { },
    soundcloudMedia = [],            // ⬅️ default to []
    soundcloudUser = [],             // ⬅️ default to []
    getArtists = () => { },
    modalOpen,
    setModalOpen,
    trackID,
    setTrackID,
    getArtistTrackID = () => { },
    getArtistTracks = () => { }
}) => {

    const [showRemix, setShowRemix] = useState(false);
    const [autoPickLoading, setAutoPickLoading] = useState(false);
    const [autoPickSummary, setAutoPickSummary] = useState(null);
    const [officialHandle, setOfficialHandle] = useState('');
    const [handleLookupLoading, setHandleLookupLoading] = useState(false);
    const [handleLookupError, setHandleLookupError] = useState('');
    const [handleLookupSummary, setHandleLookupSummary] = useState('');

    const restoreArtistsScroll = () => {
        document.documentElement.classList.add('artists-scroll-page');
        document.body.classList.add('artists-scroll-page');
        document.body.classList.remove('modal-open');
        document.body.style.removeProperty('overflow');
        document.body.style.removeProperty('overflow-y');
        document.body.style.removeProperty('padding-right');
    };

    const setMedia = (track) => {
        fetch(`/api/media/`, {
            method: 'POST',
            body: JSON.stringify({
                mediaRefGUID: artistGUID,
                mediaURL: track.id,
                mediaType: 'Soundcloud',
                mediaMetaData: JSON.stringify({
                    favorites: track.favoritings_count,
                    comments: track.comment_count,
                    plays: track.playback_count,
                    reposts: track.reposts_count
                }),
                mediaOrder: 0,
                mediaWidth: 0,
                mediaHeight: 0,
                mediaLength: track.duration,
                mediaActive: 1
            }),
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.ok) { // Checks if the status is in the range 200-299
                    getArtists();
                    return response.json();
                } else {
                    return null;
                }
            })
            // .then(() => {
            //         getArtistTracks(); // Only set data if HTTP status is 200-299
            //         setModalOpen(true);
            // })
            .catch((error) => {
            });
    };

    const removeMedia = (mediaGUID) => {
        fetch(`/api/media/${mediaGUID}`, {
            method: 'DELETE',
        })
            .then((response) => {
                if (response.ok) { // Checks if the status is in the range 200-299
                    getArtists();
                    return null;
                } else {
                    return null;
                }
            })
            .catch((error) => {
            });
    };

    const associateUser = (user) => {
        fetch(`/api/media/`, {
            method: 'POST',
            body: JSON.stringify({
                mediaRefGUID: artistGUID,
                mediaURL: user.id,
                mediaType: 'Soundcloud User',
                mediaMetaData: JSON.stringify({
                    followers: user.followers_count,
                    fullName: user.full_name,
                    username: user.username,
                    permalink: user.permalink,
                    trackCount: user.track_count
                }),
                mediaOrder: 0,
                mediaWidth: 0,
                mediaHeight: 0,
                mediaLength: 0,
                mediaActive: 1
            }),
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.ok) { // Checks if the status is in the range 200-299
                    getArtists();
                    getArtistTracks();
                    return response.json();
                } else {
                    return null;
                }
            })
            .catch((error) => {
            });
    };

    const associateUserRequest = (user) => {
        return fetch(`/api/media/`, {
            method: 'POST',
            body: JSON.stringify({
                mediaRefGUID: artistGUID,
                mediaURL: user.id,
                mediaType: 'Soundcloud User',
                mediaMetaData: JSON.stringify({
                    followers: user.followers_count,
                    fullName: user.full_name,
                    username: user.username,
                    permalink: user.permalink,
                    trackCount: user.track_count
                }),
                mediaOrder: 0,
                mediaWidth: 0,
                mediaHeight: 0,
                mediaLength: 0,
                mediaActive: 1
            }),
            headers: { 'Content-Type': 'application/json' },
        }).then((response) => {
            if (!response.ok) {
                throw new Error('Unable to associate SoundCloud profile');
            }
            return response.json().catch(() => null);
        });
    };

    const unassociateUser = (mediaGUID) => {
        fetch(`/api/media/${mediaGUID}`, {
            method: 'DELETE',
        })
            .then((response) => {
                if (response.ok) { // Checks if the status is in the range 200-299
                    getArtists();
                    getArtistTracks();
                    return null;
                } else {
                    return null;
                }
            })
            .catch((error) => {
            });
    };

    const unassociateUserRequest = (mediaGUID) => {
        return fetch(`/api/media/${mediaGUID}`, {
            method: 'DELETE',
        }).then((response) => {
            if (!response.ok) {
                throw new Error('Unable to remove existing SoundCloud profile');
            }
            return null;
        });
    };

    const fetchTracksForArtistId = (artistId) => {
        return fetch('/api/soundcloud/artist/tracks', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ artistId })
        })
            .then((response) => response.ok ? response.json() : null)
            .then((trackJson) => {
                if (trackJson?.data) {
                    setArtistPersonalTracks(trackJson.data.slice(0, 10));
                }
                return trackJson;
            });
    };

    const autoPickMedia = () => {
        if (autoPickLoading) return;

        setAutoPickLoading(true);
        setAutoPickSummary(null);

        fetch('/api/soundcloud/artist/auto-media', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                artistGUID,
                dryRun: false,
                onlyMissing: false,
                longSetCount: 1,
                songCount: 3,
                minTrackConfidence: 0.72
            })
        })
            .then(async (response) => {
                const json = await response.json().catch(() => null);
                if (!response.ok) {
                    throw new Error(json?.error || 'Auto media association failed');
                }
                return json;
            })
            .then((json) => {
                setAutoPickSummary(json);
                getArtists();
            })
            .catch((error) => {
                setAutoPickSummary({ error: error.message || 'Auto media association failed' });
            })
            .finally(() => {
                setAutoPickLoading(false);
            });
    };

    const normalizeHandle = (value = '') => {
        return String(value)
            .trim()
            .toLowerCase()
            .replace(/^https?:\/\/(www\.)?soundcloud\.com\//, '')
            .replace(/^@/, '')
            .split(/[/?#]/)[0]
            .replace(/[^a-z0-9._-]/g, '');
    };

    const lookupOfficialHandle = () => {
        const normalizedHandle = normalizeHandle(officialHandle);
        if (!normalizedHandle || handleLookupLoading) return;

        setHandleLookupLoading(true);
        setHandleLookupError('');
        setHandleLookupSummary('');

        fetch('/api/soundcloud/artist/resolve-handle', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ handle: normalizedHandle })
        })
            .then(async (response) => {
                const json = await response.json().catch(() => null);
                if (!response.ok) {
                    throw new Error(json?.error || 'Handle lookup failed');
                }
                return json;
            })
            .then((json) => {
                const resolvedUser = json?.data || null;
                const users = resolvedUser ? [resolvedUser] : [];

                setArtistSearch(users);

                const best = users[0];
                if (!best?.id) {
                    throw new Error('No matching SoundCloud profile found for that handle');
                }

                const currentAssociation = soundcloudUser.find(
                    (scUser) => Number(scUser.mediaURL) === Number(best.id)
                );

                const removals = soundcloudUser
                    .filter((scUser) => Number(scUser.mediaURL) !== Number(best.id))
                    .map((scUser) => unassociateUserRequest(scUser.mediaGUID));

                return Promise.all(removals)
                    .then(() => {
                        if (currentAssociation) return null;
                        return associateUserRequest(best);
                    })
                    .then(() => fetchTracksForArtistId(best.id))
                    .then(() => {
                        setHandleLookupSummary(`Associated @${best.permalink || best.username}`);
                        getArtists();
                    });
            })
            .catch((error) => {
                setHandleLookupError(error.message || 'Handle lookup failed');
            })
            .finally(() => {
                setHandleLookupLoading(false);
            });
    };

    const formatDateToMDY = (dateString) => {
        const date = new Date(dateString);
        if (isNaN(date)) return "Invalid Date"; // Handle incorrect date formats

        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear().toString().slice(-2)}`;
    }

    const getBackgroundColor = (isLong, isPersonal) => {
        if (isLong && isPersonal) {
            return '#69beff';
        } else if (isLong && !isPersonal) {
            return '#eeeeee';
        } else if (!isLong && isPersonal) {
            return '#b3deff';
        } else /*if (!isLong && !isPersonal)*/ {
            return 'transparent';
        }
    }

    const renderDetail = (track, isLong = false, isPersonal = false) => {
        return (
            <Row key={track.id} className='my-2 border-bottom py-2' style={{ fontSize: 13, backgroundColor: getBackgroundColor(isLong, isPersonal) }} >
                <Col xs={12}>{track.title}</Col>
                <Col md={10}>
                    <iframe
                        width="100%"
                        height="120"
                        scrolling="no"
                        frameBorder="no"
                        allow="autoplay"
                        src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${track.id}&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_artwork=false&show_reposts=false&show_teaser=false&download=false&sharing=false`}>
                    </iframe>
                    {/* Track {track.title} {track.id} */}
                </Col>
                <Col className='text-end'>
                    {soundcloudMedia.findIndex(media => parseInt(media.mediaURL) === track.id) === -1 ?
                        <Button color="primary"
                            onClick={() => setMedia(track)}
                        >Add</Button>
                        :
                        <Button color="danger"
                            onClick={() => removeMedia(soundcloudMedia.find(media => parseInt(media.mediaURL) === track.id).mediaGUID)}
                        >Remove</Button>
                    }
                </Col>
                <Col md={2}>
                    {Number(track.favoritings_count).toLocaleString()} Likes
                </Col>
                <Col md={2}>
                    {Number(track.comment_count).toLocaleString()} Comments
                </Col>
                <Col md={2}>
                    {Number(track.playback_count).toLocaleString()} Plays
                </Col>
                <Col md={2}>
                    {Number(track.reposts_count).toLocaleString()} Reposts
                </Col>
                <Col md={4}>
                    Posted {formatDateToMDY(track.created_at)} by {track.user?.username}
                </Col>
            </Row>
        )
    }

    const userSearchRenderDetail = (user) => {
        const associatedIdx = soundcloudUser.findIndex(
            scUser => Number(scUser.mediaURL) === Number(user.id)
        );
        const associatedItem = associatedIdx > -1 ? soundcloudUser[associatedIdx] : null;

        return (
            <Row key={user.id} className='my-2 border-bottom py-2' style={{ fontSize: 13, backgroundColor: '#cccc00' }} >
                <Col md={4}>
                    <div>{user.username}</div>
                    {user.permalink && (
                        <div className='text-secondary'>@{user.permalink}</div>
                    )}
                </Col>
                <Col md={2}>
                    {Number(user.track_count).toLocaleString()} Track Count
                </Col>
                <Col md={2}>
                    {Number(user.followers_count).toLocaleString()} Followers
                </Col>
                <Col md={4} className='text-end'>
                    {associatedIdx === -1 ? (
                        <Button color="primary" onClick={() => associateUser(user)}>
                            Associate
                        </Button>
                    ) : (
                        <Button color="danger" onClick={() => unassociateUser(associatedItem.mediaGUID)}>
                            Unassociate
                        </Button>
                    )}
                </Col>
            </Row>
        );
    };

    const associatedIdSet = new Set(soundcloudUser.map(u => Number(u.mediaURL)));
    const matchedUsers = artistSearch.filter(u => associatedIdSet.has(Number(u.id)));

    const usersToRender = (matchedUsers.length > 0 ? matchedUsers : artistSearch).slice(); // slice() to avoid mutating props

    usersToRender.sort((a, b) => Number(b.followers_count || 0) - Number(a.followers_count || 0));

    return (
        <Modal size="xl"
            onClosed={() => {
                setTrackID('')
                setArtistTracks([]);
                setArtistLongTracks([]);
                setArtistSearch([]);
                setAutoPickSummary(null);
                setOfficialHandle('');
                setHandleLookupError('');
                setHandleLookupSummary('');
                restoreArtistsScroll();
            }}
            centered
            isOpen={modalOpen}
            className='text-left'
            toggle={() => setModalOpen((prev) => !prev)}
        >
            <ModalHeader toggle={() => setModalOpen((prev) => !prev)}>
                {artistName} Tracks
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col>
                        <Label>
                            <Input type="checkbox" checked={showRemix} onChange={() => setShowRemix(!showRemix)} className='me-3' />
                            Show Remixes
                        </Label>
                    </Col>
                    <Col>
                        <Input type="text" placeholder='Custom Track ID' value={trackID} onChange={(e) => setTrackID(e.target.value)} className='me-3' />
                    </Col>
                    <Col>
                        <Button
                            color="primary"
                            onClick={() => getArtistTrackID()}>
                            Get Track
                        </Button>
                    </Col>
                    <Col className='text-end'>
                        <Button
                            color="secondary"
                            disabled={autoPickLoading}
                            onClick={autoPickMedia}
                        >
                            {autoPickLoading ? 'Picking...' : 'Auto Pick 1+3'}
                        </Button>
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col md={8}>
                        <Input
                            type="text"
                            placeholder='Official SoundCloud handle (e.g. @artist or soundcloud.com/artist)'
                            value={officialHandle}
                            onChange={(e) => setOfficialHandle(e.target.value)}
                        />
                    </Col>
                    <Col md={4} className='text-end'>
                        <Button
                            color='secondary'
                            disabled={handleLookupLoading || !normalizeHandle(officialHandle)}
                            onClick={lookupOfficialHandle}
                        >
                            {handleLookupLoading ? 'Looking up...' : 'Lookup Handle'}
                        </Button>
                    </Col>
                </Row>
                {handleLookupError && (
                    <Row className='mt-1'>
                        <Col className='text-danger' style={{ fontSize: 12 }}>
                            {handleLookupError}
                        </Col>
                    </Row>
                )}
                {handleLookupSummary && (
                    <Row className='mt-1'>
                        <Col className='text-secondary' style={{ fontSize: 12 }}>
                            {handleLookupSummary}
                        </Col>
                    </Row>
                )}
                {autoPickSummary && (
                    <Row className='mt-2'>
                        <Col className='text-secondary' style={{ fontSize: 12 }}>
                            {autoPickSummary.error
                                ? `Auto pick error: ${autoPickSummary.error}`
                                : (() => {
                                    const result = autoPickSummary.results?.[0];
                                    const longCount = result?.selectedLongSets?.length || 0;
                                    const songCount = result?.selectedSongs?.length || 0;
                                    const status = result?.status || 'done';
                                    return `Auto pick ${status}: added ${longCount} long set(s) and ${songCount} song(s).`;
                                })()}
                        </Col>
                    </Row>
                )}
                {usersToRender
                    .map(user => userSearchRenderDetail(user))}
                {artistLongTracks
                    .filter(track => (String(track.title).toLocaleLowerCase().indexOf('remix') === -1 || showRemix))
                    .map(track => renderDetail(track, true, false))}
                {artistPersonalTracks
                    .map(track => renderDetail(track, false, true))}
                {artistTracks
                    .filter(track => (String(track.title).toLocaleLowerCase().indexOf('remix') === -1 || showRemix))
                    .map(track => renderDetail(track, false, false))}
            </ModalBody>
            <ModalFooter style={{ display: "block" }}>
                <Row>
                    <Button
                        color="primary"
                        className='ml-2'
                        onClick={() => setModalOpen(false)}>
                        Close
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    );
}

export default ArtistTrackDownloadModal;
